<template>
    <v-card>
        <v-card-title>
        <span class="headline">Claim Type</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-autocomplete :items="appIdList" v-model="selectedClmType.appId" :label="labels.appId" item-text="label" item-value="value"
                  data-vv-name="appId" :data-vv-as="labels.appId" :error-messages="errors.collect('appId')" v-validate="'required'"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.appId}}</v-subheader>
                <div class="title">{{appID[selectedClmType.appId]}}</div>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'new'">
                <v-text-field v-model="selectedClmType.clmType" :label="labels.clmType" :error-messages="errors.collect('clmType')" v-validate="'required|max:4'"
                  data-vv-name="clmType" :data-vv-as="labels.clmType"/>
              </v-flex>
              <v-flex xs12 sm6 v-if="mode === 'review' || mode === 'query'">
                <v-subheader class="queryLabel">{{labels.clmType}}</v-subheader>
                <div class="title">{{selectedClmType.clmType}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-if="mode === 'new' || mode === 'review'" v-model="selectedClmType.seqNo" :label="labels.seqNo" :error-messages="errors.collect('seqNo')" v-validate="'required|numeric|min:0|max_value:999'"
                  data-vv-name="seqNo" :data-vv-as="labels.seqNo"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.seqNo}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmType.seqNo}}</div>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field v-if="mode === 'new' || mode === 'review'" v-model="selectedClmType.clmTypeDesc" :label="labels.clmTypeDesc" :error-messages="errors.collect('clmTypeDesc')"
                  v-validate="'required|max:200'" data-vv-name="clmTypeDesc" :data-vv-as="labels.clmTypeDesc"/>
                <v-subheader v-if="mode === 'query'" class="queryLabel">{{labels.clmTypeDesc}}</v-subheader>
                <div v-if="mode === 'query'" class="title">{{selectedClmType.clmTypeDesc}}</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox :readonly="mode === 'query'" v-model="selectedClmType.permMultiClmt" :label="labels.permMultiClmt" data-vv-name="permMultiClmt" :data-vv-as="labels.permMultiClmt"
                  :error-messages="errors.collect('permMultiClmt')"/>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel" :disabled="submitting">Cancel</v-btn>
        <v-btn color="primary" v-if="mode === 'review' || mode === 'new'" flat @click.native="doSave" :loading="submitting">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  props: {
    'selectedClmType': Object,
    'mode': String
  },
  data() {
    return {
      labels: {
        appId: 'Module',
        clmType: 'Claim Type*',
        clmTypeDesc: 'Description*',
        seqNo: 'Sequence No.*',
        permMultiClmt: 'Permit multiple claimants'
      },
      appID: {
        'TR': 'Travel',
        'MD': 'Maid',
        'FI': 'Fire',
        'CA': 'Cargo',
        'PK': 'Package'
      },
      submitting: undefined
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    appIdList() {
      let result = []
      let appID = this.appID
      Object.keys(appID).forEach(function (key) {
        const status = appID[key]
        result.push({
          label: key + ' - ' + status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.mode === 'new') this.doCreate()
          if (this.mode === 'review') this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.claimParam.menu.createClmType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.selectedClmType)
          const { data } = result
          if (data.clmType) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Unable to create claim type (Missing API URL)')
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.claimParam.menu.updateClmType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.selectedClmType)
          const { data } = result
          if (data.clmType) {
            this.notify(data)
            this.$emit('fetchData')
            this.$emit('close')
          } else {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      } else {
        this.$snotify.error('Unable to update claim type (Missing API URL)')
      }
    },
    doCancel() {
      this.resetMessages()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
